module.exports = __webpack_public_path__ + "img/13.9.TU.5bf4f32d.png";